import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { DemoOne } from "./components/ui/demo";
import axios from "axios";
import Hero from "./components/Hero";
import Contact from "./components/Contact";
import Steps from "./components/Steps";
import CookieConsent from "./components/CookieConsent";
import FloatingWhatsApp from "./components/FloatingWhatsApp";
import { WHY_US, LINKS } from "./mock";
import { Card, CardContent } from "./components/ui/card";
import { Button } from "./components/ui/button";
import { Badge } from "./components/ui/badge";
import { ShieldCheck } from "lucide-react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Toaster } from "./components/ui/sonner"; // fallback if used
import { Toaster as ShadcnToaster } from "./components/ui/toaster";

gsap.registerPlugin(ScrollTrigger);

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function WhyUsSection() {
  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.utils.toArray("[data-why]").forEach((el) => {
        gsap.from(el, {
          scrollTrigger: { trigger: el, start: "top 85%" },
          y: 16,
          opacity: 0,
          duration: 0.6,
          ease: "power2.out",
        });
      });
    });
    return () => ctx.revert();
  }, []);

  return (
    <section id="warum" className="bg-[#f5f7f8] text-neutral-900 border-t border-black/10">
      <div className="mx-auto max-w-7xl px-6 py-16">
        <div className="flex items-center gap-3">
          <Badge className="bg-black/5 text-neutral-900">Deine Vorteile</Badge>
          <h2 className="text-3xl md:text-4xl font-bold">
            {"Deine Vorteile mit HAK Gutachten – erfahren, digital, seriös"}
          </h2>
        </div>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-4">
          {WHY_US.map((item, i) => (
            <div
              key={i}
              data-why
              className="flex items-start gap-3 rounded-lg border border-black/10 bg-white p-4 hover:shadow-lg transition-shadow"
            >
              <div className="mt-1 h-2 w-2 rounded-full bg-[var(--brand-red)]" />
              <p className="text-sm text-neutral-700">{item}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

const Home = () => {
  const helloWorldApi = async () => {
    try {
      const response = await axios.get(`${API}/`);
      console.log(response.data.message);
    } catch (e) {
      console.error(e, `errored out requesting / api`);
    }
  };

  useEffect(() => {
    helloWorldApi();
  }, []);

  return (
    <div className="App">
      <a href="#main-content" className="skip-link">Zum Hauptinhalt springen</a>
      <Hero />
      <main id="main-content">
      <Steps />
      <WhyUsSection />
      <Contact />

      {/* Floating WhatsApp Button - nur außerhalb Hero sichtbar */}
      <FloatingWhatsApp />

      {/* Toasters for form feedback */}
      <ShadcnToaster />
      <Toaster />
      
      </main>
      
      {/* Cookie Consent */}
      <CookieConsent />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/demo" element={<DemoOne />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;